import { CustomContainer, OwlCarousel } from "../../atoms/DependencyHelper";
import {
  componentCheckSize,
  createMarkup,
} from "../../../utils/helperServices";
import styles from "./NextStepsInfo.module.scss";

const NextStepsInfo = ({
  heading,
  type,
  content,
  subContent,
  userEmail,
  className,
  headingClassName,
}) => {
  let stepCarousel;
  const isTablet = componentCheckSize() <= 996;

  const next = () => {
    if (stepCarousel) {
      stepCarousel.next(600);
    }
  };
  const prev = () => {
    if (stepCarousel) {
      stepCarousel.prev(600);
    }
  };

  const carouselOptions = {
    nav: false,
    autoplay: false,
    // animateIn: "animate__fadeIn",
    autoWidth: false,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsContainer: ".owl--next-step-dots",
    dotClass: "owl--next-step-dot",
    mouseDrag: true,
    touchDrag: true,
    slideBy: 1,
    dots: true,
    smartSpeed: 600,
    responsive: {
      0: {
        margin: 16,
        items: 1,
      },
      576: {
        margin: 16,
        items: 2,
      },
      768: {
        margin: 24,
        items: 3,
      },
    },
  };

  const replaceStaticEmail = (str) => {
    if (str && str !== "" && userEmail && str.match(/{{email}}/g)) {
      return str.replace("{{email}}", userEmail);
    } else {
      return str;
    }
  };

  const DisplayItemView = ({ content }) => {
    if (isTablet) {
      return (
        <OwlCarousel ref={(c) => (stepCarousel = c)} options={carouselOptions}>
          {content.map((item, index) => (
            <CustomContainer className={styles["item"]} key={index}>
              <span id="item-img" className={styles["icon"]}>
                <img src={item.icon} />
              </span>

              <span id="item-title" className={styles["title"]}>
                {item.title}
              </span>
              {item.description && (
                <span
                  id="item-desc"
                  className={styles["desc"]}
                  dangerouslySetInnerHTML={createMarkup(
                    replaceStaticEmail(item.description)
                  )}
                ></span>
              )}
            </CustomContainer>
          ))}
        </OwlCarousel>
      );
    } else {
      return (
        <>
          {content.map((item, index) => (
            <CustomContainer className={styles["item"]} key={index}>
              <span id="item-img" className={styles["icon"]}>
                <img src={item.icon} />
              </span>
              <span id="item-title" className={styles["title"]}>
                {item.title}
              </span>
              {item.description && (
                <span
                  id="item-desc"
                  className={styles["desc"]}
                  dangerouslySetInnerHTML={createMarkup(
                    replaceStaticEmail(item.description)
                  )}
                ></span>
              )}
            </CustomContainer>
          ))}
        </>
      );
    }
  };

  return (
    <CustomContainer className={`${styles["next-steps-info"]} ${className}`}>
      <div className={`${styles["section-heading"]} ${headingClassName}`}>
        {heading}
      </div>
      <CustomContainer className={styles["main-wrapper"]}>
        <CustomContainer
          className={`${styles["items"]} ${
            type == "step" ? styles["step-type"] : ""
          }`}
        >
          <DisplayItemView content={content} />
        </CustomContainer>
        {subContent && (
          <CustomContainer className={styles["sub-content"]}>
            <img src={subContent.icon} className={styles["icon"]} />
            <span
              id="sub-content-desc"
              className={styles["desc"]}
              dangerouslySetInnerHTML={createMarkup(subContent.description)}
            ></span>
          </CustomContainer>
        )}
      </CustomContainer>

      <div className="owl--next-step-dots"></div>
    </CustomContainer>
  );
};

NextStepsInfo.defaultProps = {
  type: "step",
  content: [],
  subContent: null,
};

export default NextStepsInfo;
